import { useEffect } from "react";

const useOutsideClick = (ref: React.RefObject<HTMLDetailsElement>) => {
  const handleClick = (e: { target: any; }) => {
    if (ref.current && !ref.current.contains(e.target)) {
      ref.current.removeAttribute("open");
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
